// src/pdf/pdfSanitize.js

/**
 * pdf-lib 1.17.1 carica il corpo del PDF in modo lineare, quindi da un template
 * con update incrementale conserva sia la revisione morta (`N 0 obj`) sia quella
 * viva (`N 1 obj`). In fase di salvataggio le due finiscono come entry separate
 * con lo stesso object number, e la xref le assorbe senza aprire una nuova
 * subsection: da li' in poi tutti gli offset slittano di una posizione e il
 * /Root non e' piu' risolvibile. Chrome ricostruisce la xref e apre comunque il
 * file, Adobe Acrobat lo rifiuta.
 *
 * Rimuove dal context le generation obsolete, tenendo per ogni object number un
 * solo oggetto: il Root se e' tra i duplicati, altrimenti la generation piu'
 * alta (la revisione viva).
 *
 * Va richiamata subito prima di `pdfDoc.save()`.
 */
export function removeSupersededObjects(pdfDoc) {
  const context = pdfDoc.context;
  const rootRef = context.trailerInfo.Root;

  const byObjectNumber = new Map();

  for (const [ref] of context.enumerateIndirectObjects()) {
    const refs = byObjectNumber.get(ref.objectNumber) || [];
    refs.push(ref);
    byObjectNumber.set(ref.objectNumber, refs);
  }

  const removed = [];

  for (const refs of byObjectNumber.values()) {
    if (refs.length < 2) continue;

    refs.sort((a, b) => a.generationNumber - b.generationNumber);

    const keep = refs.includes(rootRef) ? rootRef : refs[refs.length - 1];

    for (const stale of refs) {
      if (stale === keep) continue;

      context.delete(stale);
      removed.push(String(stale));
    }
  }

  return removed;
}
